<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
          <vue-element-loading size='64' is-full-screen :active='isLoadingForm' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>إصدار ايصالات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم تحديد وانشاء كشوف التحصيل و الصيانة
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class="col-lg-10 col-md-9 col-sm-12">
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                    <label>الفرع</label>
                                    <select  @change='FillItineraries()' class="form-control"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>المنطقة:</label>
                                <select class="form-control" style="padding: 0px" v-model="region_id">
                                  <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.region_name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>الاسم/الشهرة</label>
                                  <input v-model='name' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>رقم المحمول</label>
                                  <input v-model='mobile' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>المحافظة</label>
                                  <select  @change='FillCitys()' class="form-control" style="padding: 0px" v-model="governorate">
                                    <option v-for="(item) in governorates" v-bind:key="item.id" v-bind:value="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>المدينة/المركز</label>
                                  <vue-element-loading size='32' :active='isLoadingCitys' spinner='bar-fade-scale' color='#A4A4A4'/>
                                  <select class="form-control" style="padding: 0px" v-model="city">
                                    <option v-for="(city) in cities" v-bind:key="city.id" v-bind:value="city.id">
                                      {{ city.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-6 col-md-8 col-sm-6'>
                                <div class="form-group">
                                  <label>القرية العنوان</label>
                                  <input v-model='village' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>المديونية</label>
                                  <select class="form-control"  v-model="balance">
                                    <option value='0'></option>
                                    <option value='1'>مدين</option>
                                    <option value='2'>غير مدين</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>التقييم</label>
                                  <select class="form-control"  v-model="evaluation">
                                    <option value='0'></option>
                                    <option value='1'>غير مقيم</option>
                                    <option value='2'>سيئ جدا</option>
                                    <option value='3'>سيئ</option>
                                    <option value='4'>جيد</option>
                                    <option value='5'>جيد جدا</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>الحالة</label>
                                  <select class="form-control" v-model="isActive">
                                    <option value='0'></option>
                                    <option value='2'>نشط</option>
                                    <option value='1'>غير نشط</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>الترتيب</label>
                                  <select class="form-control"  v-model="sorte">
                                    <option value='customers.rec_id'></option>
                                    <option value='customers.id'>الكود</option>
                                    <option value='customers.branche_id'>الفرع</option>
                                    <option value='line_id'>الخط</option>
                                    <option value='region_id'>المنطقة</option>
                                    <option value='village'>القرية</option>
                                    <option value='rec_id'>السجل</option>
                                    <option value='customers.name'>الاسم</option>
                                    <option value='evaluation'>التقييم</option>
                                    <option value='customers.balance'>الرصيد</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-6 col-md-6 col-sm-6'>
                                <div class="form-group">
                                  <label>النوع</label>
                                      <div :class="isType1 ? 'form-group input-group' : ''" >
                                      <span  v-show='type == 1' class="input-group-addon"><input type="checkbox" v-model="isInLimit"></span>
                                      <select @change='changeType()' class="form-control"  v-model="type">
                                        <option v-for="item in callTypes" v-bind:key="item.id" v-bind:value="item.id">
                                          {{item.name}}
                                        </option>
                                      </select>
                                  </div>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <div class="form-group">
                                  <label>من رقم</label>
                                  <input @change="repetTo()" v-model='from_id' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <div class="form-group">
                                  <label>الى رقم</label>
                                  <input v-model='to_id' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div v-show='type == 1 || type == 2' class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div v-show='type == 1 || type == 2' class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                              <div v-show='type === 3' class='col-lg-6 col-md-4 col-sm-6'>
                                <label>العرض:</label>
                                <select class="form-control" style="padding: 0px" v-model="offer_id">
                                  <option  v-for="offer in offers" v-bind:key="offer.id"  v-bind:value="offer.id">
                                    {{offer.offer_name}} - {{offer.price}}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>&nbsp;</label>
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> عرض </b>
                                </button>
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-12" style="padding: 0px">
                              <!-- /.panel -->
                              <div class="chat-panel panel panel-default" >
                                  <div class="panel-heading">
                                     الخطوط
                                  </div>
                                  <!-- /.panel-heading -->
                                  <div class="panel-body" style="padding: 5px">
                                    <div v-for="(item,index) in lines" v-bind:key="index" >
                                      <input :id="index" type="checkbox" :value="item.id" v-model="selectedLine">{{' ' + item.name }}
                                    </div>
                                  </div>
                                  <!-- /.panel-body -->
                              </div>
                        </div>
                              <div style="padding:10px">
                              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                  <thead>
                                    <tr>
                                      <th style='padding:2px;text-align: center'>م</th>
                                      <th style='padding:2px;text-align: center'>السجل</th>
                                      <th style='padding:2px;text-align: center'>الاسم</th>
                                      <th style='padding:2px;text-align: center'>اسم الشهرة</th>
                                      <th style='padding:2px;text-align: center'>المنطقة</th>
                                      <th style='padding:2px;text-align: center'>القرية</th>
                                      <th style='padding:2px;text-align: center'>العنوان</th>
                                      <th style='padding:2px;text-align: center'>المحمول</th>
                                      <th v-show='type == 3' style='padding:2px;text-align: center'>التاريخ</th>
                                      <th v-show='type == 3' style='padding:2px;text-align: center'>المبلغ</th>
                                      <th v-show='type == 2' style='padding:2px;text-align: center'>العرض</th>
                                      <th v-show='type == 1' style='padding:2px;text-align: center'>العدد</th>
                                      <th v-show='type == 1' style='padding:2px;text-align: center'>الاجمالى</th>
                                      <th v-show='type > 6' style='padding:2px;text-align: center'>العرض</th>
                                      <th v-show='type > 6' style='padding:2px;text-align: center'>اخر سداد</th>
                                      <th v-show='type > 6' style='padding:2px;text-align: center'>الأيام</th>
                                      <th v-show='type > 6 || type == 2' style='padding:2px;text-align: center'>الرصيد</th>
                                      <th style='padding:2px;text-align: center'>الاجراء</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>

                                         <td align='center'>{{index +1 }}</td>
                                         <td align='center'>{{record.rec_id}}</td>
                                         <td align='center'>{{record.name}}</td>
                                         <td align='center'>{{record.nickname}}</td>
                                         <td align='center'>{{record.region_name}}</td>
                                         <td align='center'>{{record.village}}</td>
                                         <td align='center'>{{record.address}}</td>
                                        <td align='center'>{{record.mobile}} {{record.mobile2}}</td>
                                        <td v-show='type == 3' align='center'>{{record.default_date}}</td>
                                        <td v-show='type == 3' align='center'>{{record.amount}}</td>
                                        <td v-show='type == 2' align='center'>{{record.offer_name}}</td>
                                        <td v-show='type == 1' align='center'>{{record.count}}</td>
                                        <td v-show='type == 1' align='center'>{{record.total_reset}}</td>
                                        <td v-show='type > 6' align='center'>{{record.offer_name}}</td>
                                        <td v-show='type > 6' align='center'>{{record.last_pay}}</td>
                                        <td v-show='type > 6' align='center'>{{record.days}}</td>
                                        <td v-show='type > 6 || type == 2' align='center'>{{record.balance}}</td>
                                        <td align='center'>
                                          <button @click='GetAllCustomerData(record.uid, record.contract_offer_id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#ContractsForm'>عرض</button>
                                        </td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- ================ Contracts Modal Begin ======================================== -->
             <div class="modal fade" id="ContractsForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                 <div class="modal-dialog modal-lg">
                     <div class="modal-content">
                         <div class="modal-header">
                             <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                             <h4 class="modal-title" id="myModalLabel">{{contTitle}}</h4>
                         </div>
                         <div class="modal-body">
                           <div class="panel-body" style="padding:0px">

                            <vue-tabs active-tab-color="#6DBCF1"
                                      active-text-color="white"
                                      centered
                                      v-model="tabName"
                                      @tab-change="handleTabChange">
                              <v-tab title="إدراج" icon="ti-user">
                              <CreateDailyReceipts :callMethod = "callme" ref="CreateDailyReceipts"> </CreateDailyReceipts>
                              </v-tab>
                              <v-tab title="بيانات العميل" icon="ti-user">
                              <Data ref="Data"> </Data>
                                </v-tab>
                               <v-tab :disabled="disabled" id = "1" title="العقود" icon="ti-settings">
                                 <Contracts ref="Contracts"> </Contracts>
                               </v-tab>
                               <v-tab :disabled="disabled"  id = "2" title="السداد" icon="ti-check">
                                 <InstallmentPaymrnt ref="InstallmentPaymrnt"> </InstallmentPaymrnt>
                               </v-tab>
                               <v-tab :disabled="disabled" title="الصيانة" icon="ti-check">
                                 <Maintenance  ref="Maintenance"> </Maintenance>
                               </v-tab>
                               <v-tab :disabled="disabled" id = "7" title="العروض" icon="ti-check">
                                 <OM ref="OM"> </OM>
                               </v-tab>
                               <v-tab  :disabled="disabled" id = "8" title="المكالمات" icon="ti-check">
                                 <CallLogs  ref="CallLogs"> </CallLogs>
                               </v-tab>
                           </vue-tabs>
                         </div>
<!-- //////////////////////////////////.panel-heading -->
                               <!-- Nav tabs -->

                           <!-- /.panel-body -->
                         </div>
                         <div style="align-content: center;" class="modal-footer">
                             <button type="button" class="btn btn-default" data-dismiss="modal">خروج</button>
                         </div>
                     </div>
                 </div>
                 <!-- /.modal-dialog -->
             </div>
    <!-- ================  /.modal-content ======================================== -->
             <!-- /. Contracts modal End -->
             <!-- /.container-fluid -->
        </div>
</template>
<style>
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import Swal from 'sweetalert2'
import CreateDailyReceipts from '@/components/Sales/CreateDailyReceipts'
import OM from '@/components/Sales/Contracts/OM'
import Contracts from '@/components/Sales/Contracts/Contracts'
import InstallmentPaymrnt from '@/components/Sales/Contracts/InstallmentPaymrnt'
import Data from '@/components/Sales/Contracts/Data'
import Maintenance from '@/components/Sales/Contracts/Maintenance'
import CallLogs from '@/components/Sales/Contracts/CallLogs'
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'createCollectingstatement',
  components: {
    OM,
    Contracts,
    InstallmentPaymrnt,
    Maintenance,
    CallLogs,
    CreateDailyReceipts,
    Data,
    tbDate
  },
  data () {
    return {
      callTypes: [
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 7, name: 'سداد قسط عرض'},
        {id: 8, name: 'سداد مديونية صيانة'},
        {id: 2, name: 'تغيير شمع فى عرض'},
        {id: 3, name: 'عرض جديد'},
        {id: 9, name: 'طلب صيانة'}
      ],
      today: true,
      isInLimit: false,
      isType1: false,
      dateTitle: 'التاريخ',
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: '',
      emptyRec: [{id: 0, name: 0}],
      validationErrors: '',
      offers: {},
      pagination: {},
      region_id: {},
      regions: '',
      records: {},
      lines: {},
      line: '',
      selectedLine: [],
      record: {},
      offer_id: '',
      printRecord: [],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingForm: false,
      isLoadingDelete: false,
      isLoadingCitys: false,
      printRecords: [],
      branches: {},
      governorates: {},
      cities: {},
      itineraries: {},
      tabName: 'إدراج',
      title: '',
      disabled: true,
      id: '',
      name: '',
      contTitle: '',
      branche: 0,
      brancheID: 0,
      itinerarie: 0,
      notes: '',
      governorate: '',
      city: '',
      village: '',
      isActive: '',
      balance: '',
      sorte: 'rec_id',
      evaluation: '',
      mobile: '',
      from_id: '',
      to_id: '',
      type: 1
    }
  },
  mounted: function () {
    this.$root.$on('Update_Totals', (id, ind, mai, total, contractId, balance) => {
      let i = this.records.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.records[i].balance = balance
        this.$refs.Contracts.updateTotal(contractId, ind, mai)
      }
    })
    this.$root.$on('SET_Title', (Title) => {
      this.contTitle = Title
    })
    this.$root.$on('SET_Records', (RecordData, Type) => {
      this.disabled = false
      this.$refs.Contracts.UpdateData(RecordData.branche_id)
      this.$refs.InstallmentPaymrnt.UpdateData(RecordData.branche_id)
      this.$refs.Maintenance.UpdateData(RecordData.branche_id)
      this.$refs.receipt.UpdateData(RecordData.branche_id)
      if (Type === 0) {
        this.records.push(RecordData)
      } else {
        let i = this.records.map(record => record.id).indexOf(RecordData.id)
        this.records.splice(i, 1, RecordData)
      }
      this.$refs.Contracts.GetData()
    })
  },
  created () {
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
    this.governorates.unshift(this.emptyRec)
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.branche = this.branches[0].id
    this.FillItineraries()
    this.getOffres()
  },
  methods: {
    callme (data) {
      let i = this.records.findIndex(x => x.contract_offer_id === data)
      this.records.splice(i, 1)
    },
    repetTo () {
      this.to_id = this.from_id
    },
    changeType () {
      this.records = ''
      if (this.type === 1) {
        this.isType1 = true
      } else {
        this.isType1 = false
      }
    },
    getOffres () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAllActiveOffers', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.offers = data
          this.isLoadingData = false
        })
    },
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branche))
      if (i > -1) {
        this.brancheID = i
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    FillRegions (id) {
      this.regions = ''
      this.region_id = ''
      if (id != null && id.length !== 0) {
        let i = this.branches[this.brancheID].itineraries.findIndex(x => x.id === parseInt(this.line))
        if (i > -1) {
          this.regions = JSON.parse(JSON.stringify(this.branches[this.brancheID].itineraries[i].regions))
          this.regions.unshift(this.emptyRec)
        }
      }
    },
    FillCitys () {
      this.isLoadingCitys = true
      this.city = ''
      axios.post(this.$apiURL + 'get-branch-cities', {
        token: localStorage.getItem('token'),
        governorate: this.governorate
      })
        .then(res => {
          this.isLoadingCitys = false
          this.cities = res.data
          this.cities.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    saveNots () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'saveNotes', {
        token: localStorage.getItem('token'),
        notes: this.notes,
        id: this.$store.state.customerData.id
      })
        .then(({ data }) => {
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'GetMaintenanceCollectingSheetData', {
        token: localStorage.getItem('token'),
        line_id: this.selectedLine,
        branch_id: this.branche,
        region_id: this.region_id,
        name: this.name,
        governorate: this.governorate,
        city: this.city,
        village: this.village,
        mobile: this.mobile,
        date_from: this.from_date,
        date_to: this.to_date,
        evaluation: this.evaluation,
        isActive: this.isActive,
        from_id: this.from_id,
        type: this.type,
        to_id: this.to_id,
        offer_id: this.offer_id,
        balance: this.balance,
        isInLimit: this.isInLimit,
        sorte: this.sorte
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    handleTabChange (tabIndex, newTab, oldTab) {
      if (newTab.id === '1') {
        this.$refs.Contracts.tabSelected()
      } else if (newTab.id === '2') {
        this.$refs.InstallmentPaymrnt.EmptyCombo()
      } else if (newTab.id === '7') {
        this.$refs.OM.tabSelected()
      } else if (newTab.id === '8') {
        this.$refs.CallLogs.tabSelected()
      }
    },
    GetAllCustomerData (uid, offeID) {
      this.isLoadingForm = true
      this.tabName = 'إدراج'
      axios.post(this.$apiURL + 'getAllCustomerData', {
        token: localStorage.getItem('token'),
        uid: uid
      })
        .then(res => {
          this.isLoadingForm = false
          this.$store.dispatch('getAllCustomerData', res.data[0])
          this.disabled = false
          this.contTitle = 'بيانات العميل رقم ' + this.$store.state.customerData.id + ' : ' + this.$store.state.customerData.name + ' [ ' + 'كود سجل ' + this.$store.state.customerData.rec_id + ' ]'
          // this.$refs.CollectingSheets.GetData(this.from_date, this.to_date, this.branche)
          this.$refs.Data.FillData(uid)
          // -----------------------------
          if (this.$per.value.Contract_show) {
            this.$refs.Contracts.GetData()
          }
          // -----------------------------
          if (this.$per.value.Maintenance_show) {
            this.$refs.Maintenance.GetData()
          }
          // -----------------------------
          if (this.$per.value.InstallmentPaymrnt_show) {
            this.$refs.InstallmentPaymrnt.GetData()
          }
          // -----------------------------
          if (this.$per.value.Notes_show) {
            this.notes = this.$store.state.customerData.notes
          }
          this.$refs.CreateDailyReceipts.tabSelected(this.$store.state.customerData.uid, this.from_date, this.to_date, this.type, offeID)
        })
        .catch(err => {
          if (uid !== 0) {
            if (err.response.data.errors === 'Forbidden') {
              this.$router.push('accessdeny')
            }
            if (err.response.status === 401) {
              this.$router.push('login')
            }
          }
        })
    },
    deleteData (uid, id) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteCustomer', {
            token: localStorage.getItem('token'),
            id: uid
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              let i = this.records.map(record => record.id).indexOf(id)
              this.records.splice(i, 1)
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Maintenancestatement1.vue